module.exports = __webpack_public_path__ + "static/img/office-slide-3.6b8c1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office-slide-3.png
// module id = KLJa
// module chunks = 1